import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type {
  Assignee,
  InstitutionMember,
} from '@backrs_ui/grow-ui/src/redux/coachingDashboard/coachingDashboard.types';

export const useAgentContext = (member: Assignee | InstitutionMember | undefined) => {
  useRegisterAgentContext(
    member
      ? {
          kind: 'section',
          title: 'Life Readiness',
          description:
            'The Life Readiness dashboard on screen belongs to the student this page names, not to the signed-in coach. Every level and category progress bar is that student rating their own readiness.',
        }
      : null,
  );
};
